import styled from 'styled-components';
import { mediaQuery } from 'utils/mediaQueries';

export const FlexWrapper = styled.div`
  grid-row: 3;
  grid-column: 2;
  display: flex;
  flex-direction: column;
  padding-bottom: 1.5rem;
  padding-top: 1rem;

  ${mediaQuery.phone} {
    padding-left: 1rem;
    padding-right: 1rem;
    padding-bottom: 1rem;
    padding-top: 0;
  }

  ${mediaQuery.tablet} {
    grid-column: 1;
    grid-row: 3;
  }

  ${mediaQuery.phone} {
    font-size: 2rem;
  }
`;

export const ResultTitle = styled.button`
  text-align: center;
  font-size: 0.75rem;
  font-family: 'Calling-code', sans-serif;
  font-weight: 600;
  color: ${({ theme }) => theme.text.primary};
  margin-bottom: 0.5rem;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  cursor: pointer;
  border: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  width: auto;
  padding: 0;
  align-self: center;

  > span {
    background-color: ${({ theme }) => theme.highlight.primary};
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    :active {
      background-color: ${({ theme }) => theme.highlight.inverted};
      color: ${({ theme }) => theme.text.inverted};
    }
    @media (hover: hover) and (pointer: fine) {
      :hover {
        background-color: ${({ theme }) => theme.highlight.inverted};
        color: ${({ theme }) => theme.text.inverted};
      }
    }
  }

  ${mediaQuery.phone} {
    font-size: 1rem;
  }

  ${mediaQuery.phone} {
    font-size: 1rem;
  }
`;

export const ReasonText = styled.div`
  color: ${({ theme }) => theme.text.primary};
  /* font-family: 'Gothicus'; */
  font-family: 'New Tegomin', serif;
  font-weight: 700;
  font-size: 1.7rem;
  text-align: center;
  padding-left: 1rem;
  padding-right: 1rem;
  line-height: 2rem;
`;
